import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { MapOxxoTeam2TopicOne } from "./subTopicOne/MapOxxoTeam2TopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { ContainerCleaning } from "./subTopicOne/ContainerCleaning";
import { CameraController } from "../../../componets3D/CameraController";
import { PlaneSelect } from "../../objects/PlaneSelect";
import { FastFoodUnclean } from "./subTopicOne/FastFoodUnclean";

export class SceneTeam2TopicOne extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.renderAnimations();
		this.observerListeners();

		this.totalObjectActTwo = 5
		this.selectObjectActTwo = 0
	}

	create() {
		this.mapmenu = new MapOxxoTeam2TopicOne(this.loadingManager);
		this.add(this.mapmenu);
		this.add(this.characterSelected);
		this.containerCleaning = new ContainerCleaning(this.loadingManager);
		this.planeSalchichas = new PlaneSelect("Salchichas", 0xffffff);
		this.planePanes = new PlaneSelect("Panes", 0xffffff);
		this.fastFoodClean = new FastFoodUnclean(this.loadingManager);
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	sceneActivityOneState() {
		this.fastFoodClean.visible = false
		this.mapmenu.Fast_Food.visible = true

		this.mapmenu.eliminateAnimation();
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();

		this.containerCleaning.onVisibleActOne()
		this.containerCleaning.position.set(-9.2341, -0.8529, -9.2341)
		this.containerCleaning.Pinzas.position.set(26.7597, -17.3516, 26.7597)
		this.containerCleaning.Pinzas.visible = true
		this.add(this.containerCleaning);

		this.planeSalchichas.visible = false
		this.planeSalchichas.position.set(-9.8533, -0.4447, -10.5428)
		this.planeSalchichas.scale.set(0.86, 0.60, 1)
		this.planeSalchichas.material.opacity = 0.2
		this.add(this.planeSalchichas)


		this.planePanes.visible = false
		this.planePanes.position.set(-9.9, -1.309, -10.2345)
		this.planePanes.scale.set(1.16, 0.24, 1)
		this.planePanes.material.opacity = 0.2
		this.add(this.planePanes)

		this.containerCleaning.clearAll()

		// this.camera.control.enableRotate = true;
		// 	this.camera.control.enablePan = true;
		// 	this.camera.control.enableZoom = true
		// 	this.camera.helper()

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensitySalchichas, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;

			this.camera.moveCameraToPoint(new Vector3(-9.7666, -0.314, -7.9279), 1, new Vector3(-9.791, -1.017, -10.781), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [this.planeSalchichas];
				this.planeSalchichas.visible = true
				this.planeSalchichas.onAnimationOpacity()
				this.mouseListenersEnableMovementActivityOne();
			})
			// this.camera.control.enableRotate = true;
			// this.camera.control.enablePan = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensityVerduras, () => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [this.mapmenu.Verduras];
			this.mapmenu.onAnimate(this.mapmenu.Verduras);
			this.mouseListenersEnableMovementActivityOne();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityOne.activeEmissiveIntensityClick, (type = "") => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [];

			this.planeSalchichas.visible = false
			this.planePanes.visible = false
			this.mapmenu.onAnimate()
			switch (type) {
				case "Panes":
					this.mouseEvents.objectsToValue = [this.planePanes];
					this.planePanes.visible = true
					this.planePanes.onAnimationOpacity()
					break;
				case "Verduras":
					this.mouseEvents.objectsToValue = [this.mapmenu.Verduras];
					this.mapmenu.onAnimate(this.mapmenu.Verduras);
					break;
				case "Pinzas":
					this.mouseEvents.objectsToValue = [this.containerCleaning.Pinzas];
					this.containerCleaning.onSelectAnimation("Pinzas");
					break;

				default:
					break;
			}
			this.mouseListenersEnableMovementActivityOne();
		});

	}

	sceneActivityTwoState() {
		this.fastFoodClean.onInitActiv()
		this.selectObjectActTwo = 0

		this.containerCleaning.clearAll()
		this.containerCleaning.onInVisibleAll()

		this.mapmenu.eliminateAnimation();

		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateIdle();

		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = []
		this.mouseListenersEnableMovementActivityTwo()


		this.mapmenu.Fast_Food.visible = true
		this.fastFoodClean.visible = false
		// this.fastFoodClean.position.set(0.0647, 0, 0.4704)
		this.add(this.fastFoodClean)

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityTwo.visibleFasFood, (type = 0) => {
			if (type === 0) {
				this.mapmenu.Fast_Food.visible = false
				this.fastFoodClean.visible = true
			} else {
				this.mapmenu.Fast_Food.visible = true
				this.fastFoodClean.visible = false
			}
		});


		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityTwo.moveInClearContainer, () => {

			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.8146, -0.3826, -6.1402), 1, new Vector3(-11.682, -0.937, -7.3), () => {
				this.camera.control.enableZoom = true
				this.camera.control.enableRotate = true;
				this.camera.control.maxAzimuthAngle = 0.336;
				this.camera.control.minAzimuthAngle = -0.912;
				this.camera.control.minDistance = 1.1;
				this.camera.control.maxDistance = 1.2;

				this.fastFoodClean.onAnimateAll() //! falta
			})
		});

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityTwo.onActivityClean, () => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.fastFoodClean.Manchas_Suelo_01,
				this.fastFoodClean.Maruchan_3001,
				this.fastFoodClean.Maruchan_3002,
				this.fastFoodClean.Maruchan_2001,
				this.fastFoodClean.Pinzas,
				this.fastFoodClean.Manchas_suelo_02,
				this.fastFoodClean.Gota_Cafe,
				this.fastFoodClean.Mancha_cafe,
				this.fastFoodClean.Manchas_Cafe_plancha,
				this.fastFoodClean.Manchas_Gabinete,
				this.fastFoodClean.Manchas_ketchup,
			];
			this.mouseListenersEnableMovementActivityTwo()
		});
	}

	sceneActivityThreeState() {
		this.fastFoodClean.visible = false
		this.mapmenu.Fast_Food.visible = true

		this.mapmenu.eliminateAnimation();
		this.mouseEvents.disposeInteractions();

		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateIdle();

		this.containerCleaning.position.set(-9.2341, -0.8529, -9.2341)
		this.containerCleaning.rotation.y = -0.1207
		this.containerCleaning.onInVisibleAll()
		// this.containerCleaning.helpers()
		this.add(this.containerCleaning);

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityThree.moveToTableCoffe, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-10.0855, 0.4137, -5.6945), 1, new Vector3(-9.636, -0.503, -8.45), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [];
				this.onAnimationActThree("Condimentero")
			})
		})

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityThree.viewObjectsOnly, (object = "") => {
			this.onAnimationActThree(object)
		})

		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityThree.moveInitActThree, () => {
			this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
				this.characterSelected.visible = true
			})
		})

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-11.1997, 0.1803, -6.0577), 1, new Vector3(-9.636, -0.503, -8.45), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 1.142;
					this.camera.control.minAzimuthAngle = -0.579;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.characterSelected.visible = true;
					this.characterSelected.onAnimateSaludo();
					this.activeAudio()
				});
				break;
			case 1:
				//* helados posicion 1
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 1.142;
					this.camera.control.minAzimuthAngle = -0.579;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()
					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 3.093;
					this.camera.control.minAzimuthAngle = -2.288;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.sceneActivityTwoState();
					this.activeAudio()
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = 3.093;
					this.camera.control.minAzimuthAngle = -2.288;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.sceneActivityThreeState();
					this.activeAudio()
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

				});
				break;
		}
	}

	mouseListenersEnableMovementActivityOne() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityOne.clickedRayCaster, name);
			}
		});
	}

	mouseListenersEnableMovementActivityTwo() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				const getIsRayCaster = this.fastFoodClean.onDetectObject(name)
				if (!getIsRayCaster) {
					this.selectObjectActTwo++
				}
				if (this.selectObjectActTwo === this.totalObjectActTwo) {
					ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityTwo.finishCleanAct2)
				}
			}
		});
	}


	mouseListenersEnableMovementActivityThree() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				this.containerCleaning.onSelectAnimation(name);
			}
		});
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.team2.subtopicOne.activityOne.stepUseRayCaster, (step) => {
			this.stepActive = step;
		});
	}

	onAnimationActThree(object = "") {
		switch (object) {
			case "Condimentero":
				this.containerCleaning.Condimentero.visible = true
				this.containerCleaning.onMoveObjectTarget(
					{ x: 17.9375, y: -43.8184, z: -34.9961 },
					this.containerCleaning.Condimentero,
					2,
					() => {
						this.containerCleaning.Condimentero.visible = false
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.finishAnimation, "Condimentero")
					}
				)
				break;
			case "Salchichas":
				this.containerCleaning.Salchichas.visible = true
				this.containerCleaning.onMoveObjectTarget(
					{ x: -34.9961, y: -39.4073, z: -21.7627 },
					this.containerCleaning.Salchichas,
					2,
					() => {
						this.containerCleaning.Salchichas.visible = false
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.finishAnimation, "Salchichas")
					}
				)
				break;
			case "Contenedor_verduras":
				this.containerCleaning.Contenedor_verduras.visible = true
				this.containerCleaning.onMoveObjectTarget(
					{ x: -74.6962, y: -48.2295, z: 13.5263 },
					this.containerCleaning.Contenedor_verduras,
					2,
					() => {
						this.containerCleaning.Contenedor_verduras.visible = false
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.finishAnimation, "Contenedor_verduras")
					}
				)
				break;
			case "Cepillo":
				this.containerCleaning.Cepillo.visible = true
				this.containerCleaning.onMoveObjectTarget(
					{ x: -26.1742, y: -30.585, z: 26.7596 },
					this.containerCleaning.Cepillo,
					2,
					() => {
						this.containerCleaning.Cepillo.visible = false
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.finishAnimation, "Cepillo")
					}
				)
				break;
			case "Trapo":
				this.containerCleaning.Trapo.visible = true
				this.containerCleaning.onMoveObjectTarget(
					{ x: 26.5842, y: -30.585, z: 26.7596 },
					this.containerCleaning.Trapo,
					2,
					() => {
						this.containerCleaning.Trapo.visible = false
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.finishAnimation, "Trapo")
					}
				)
				break;

			case "Pinzas":
				this.containerCleaning.Pinzas.visible = true
				this.containerCleaning.onMoveObjectTarget(
					{ x: 60.8259, y: -30.585, z: 26.7596 },
					this.containerCleaning.Pinzas,
					2,
					() => {
						this.containerCleaning.Pinzas.visible = false
						ObserverEmitter.emit(EVENTS.team2.subtopicOne.activityThree.finishAnimation, "Pinzas")
					}
				)
				break;

			default:
				break;
		}
	}

	renderAnimations(delta) { }
}
